<script setup>
import { computed, ref, watch } from 'vue'
import { usePage, router } from '@inertiajs/vue3'
import OverviewChangeRequest from './OverviewChangeRequest.vue'

const page    = usePage()
const rawData = computed(() => page.props.__neo_main?.__data)

const list = ref([])

watch(rawData, (data) => {
    list.value = data?.changes ?? []
}, { immediate: true })

function approve(id) {
    list.value = list.value.filter(r => r.id !== id)
    router.visit(route('app.forms.accept', { request: id }), { preserveState: true, preserveScroll: true })
}

function reject(id) {
    list.value = list.value.filter(r => r.id !== id)
    router.visit(route('app.forms.reject', { request: id }), { preserveState: true, preserveScroll: true })
}
</script>

<template>
    <div>
        <div v-if="!list.length" class="text-[13px] text-gray-400 dark:text-neutral-500 py-3">{{ $t('dashboard.changes_empty') }}</div>
        <OverviewChangeRequest
            v-for="req in list"
            :key="req.id"
            :request="req"
            @approve="approve"
            @reject="reject"
        />
    </div>
</template>
